import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import HomepageNavbar from "@xtribe/shared/components/lib/Navbar/HomepageNavbar";
import Image from "next/image";
import OnboardingStartForm from "../components/Onboarding/OnboardingStartForm";

const OnboardingPage = ({}) => {
  return (
    <div className="theme-admin overflow-x-hidden overflow-y-hidden">
      <NextHead
        title={"Starte dein 14 Tage Probeabo mit xTribe"}
        description={
          "Vermarkte eigenen Content und biete Premium-Abonnements, die es in sich haben und erschaffe dein ortsunabhängiges Business, rund um deine kreative Arbeit."
        }
      />
      <HomepageNavbar hideButtons />
      <Layout>
        <div className="flex flex-col lg:flex-row min-h-screen h-full">
          <div className="lg:w-2/5 px-8 py-20 h-full lg:min-h-screen flex flex-col justify-center items-center ">
            <OnboardingStartForm />
          </div>
          <div className="lg:w-3/5 h-full lg:min-h-screen bg-green  text-white flex flex-col items-center justify-center text-center px-4 py-12 lg:p-24">
            <div className="max-w-2xl mx-auto">
              <Image
                src="/static/logo/xtribe-logo-square.png"
                height={196}
                width={196}
              />
              <h1 className="h1 lg:mt-8">Unsere Mission</h1>
              <p className="text-xl opacity-90 mt-12">
                Wir glauben, dass Creator, die ihr wissen teilen, das Talent
                haben Menschen zu inspirieren und ihre Expertise schon jetzt an
                ein Zielpublikum vermitteln, nicht leer aus gehen sollten.
                <br />
                Mache aus Fans zahlende Mitglieder deines Coding, Yoga, Fitness,
                Dance oder Mindfulness Tribes. Oder starte deinen ganz
                individuellen Tribe.
                <br />
                Kümmere dich um die Leute, die an dich glauben und gerne deinen
                Live Kurs buchen, deinen erstellten Content kaufen und dich um
                Rat und Tat fragen.
                <br />
                Verantwortung, Vertrauen und Vielseitigkeit macht aus fremden
                Fans einen einzigartigen Tribe. Deinen Tribe.
              </p>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default OnboardingPage;
